/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Status_Banner_Live_SinceInputs */



/**
* | output |
* | --- |
* | "Live since {time}" |
*
* @param {Status_Banner_Live_SinceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const status_banner_live_since = /** @type {((inputs: Status_Banner_Live_SinceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_Banner_Live_SinceInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Aktiv seit ${i?.time}`)
	return /** @type {LocalizedString} */ (`Live since ${i?.time}`)
});